export const PILL_STYLES = {
    SUCCESS: 'success',
    INFO: 'info',
    WARNING: 'warning',
    DANGER: 'danger',
    CLOSED: 'closed',
    EMPTY: '',
};
